module.exports = __webpack_public_path__ + "img/95.65c9018b.jpg";